import React from "react";
import { Box } from "theme-ui";

interface MinusButtonProps {
  onClick: () => void;
}

function PlusButton({ onClick }: MinusButtonProps) {
  return (
    <Box
      as="button"
      sx={{
        backgroundColor: "#fff",
        border: "1px solid",
        borderColor: "#000",
        borderRadius: "3px",
        cursor: "pointer",
        display: "block",
        position: "absolute",
        width: "20px",
        height: "20px",
        right: 0,
        top: "5px",
        "&::before": {
          backgroundColor: "#000",
          content: '""',
          display: "block",
          height: "2px",
          left: "50%",
          marginLeft: "-5px",
          marginTop: "-1px",
          position: "absolute",
          top: "50%",
          width: "10px",
        },
        "&::after": {
          backgroundColor: "#000",
          content: '""',
          display: "block",
          height: "10px",
          left: "50%",
          marginLeft: "-1px",
          marginTop: "-5px",
          position: "absolute",
          top: "50%",
          width: "2px",
        },
      }}
      onClick={onClick}
    >
      <Box as="span" sx={{ display: "none" }}>
        plus
      </Box>
    </Box>
  );
}

export default PlusButton;
